export default __webpack_public_path__ + "static/O0050-9d0f10738f4cab6bab7c54c9f6c06924.png";